import 'bootstrap/dist/css/bootstrap.min.css';
import MachineStateView from './MachineStateView';
import './App.css';

function App() {
  return (
    <div className="App">
      <br/><br/>
          <MachineStateView/>
    </div>
  );
}

export default App;
